const WHATSAPP_OAUTH_CALLBACK_STORAGE_KEY = "CompleoWhatsappOAuthCallback";
const WHATSAPP_OAUTH_ERROR_STORAGE_KEY = "CompleoWhatsappOAuthError";

export type WhatsappOAuthCallbackSuccess = {
    kind: "success";
    code: string;
    state: string;
};

export type WhatsappOAuthCallbackError = {
    kind: "error";
    error: string;
    errorReason: string | null;
    errorDescription: string | null;
};

export type WhatsappOAuthCallbackResult =
    | WhatsappOAuthCallbackSuccess
    | WhatsappOAuthCallbackError;

export const parseWhatsappOAuthCallbackFromSearch = (
    search: string
): WhatsappOAuthCallbackResult | null => {
    const params = new URLSearchParams(search);
    const error = params.get("error");

    if (error) {
        return {
            kind: "error",
            error,
            errorReason: params.get("error_reason"),
            errorDescription: params.get("error_description")
        };
    }

    const code = params.get("code");
    const state = params.get("state");

    if (!code || !state) {
        return null;
    }

    return {
        kind: "success",
        code,
        state
    };
};

export const formatWhatsappOAuthErrorMessage = (
    callback: WhatsappOAuthCallbackError
) => {
    const parts = [callback.error];

    if (callback.errorReason) {
        parts.push(callback.errorReason);
    }

    if (callback.errorDescription) {
        parts.push(callback.errorDescription);
    }

    return parts.join(" — ");
};

export const storeWhatsappOAuthCallbackFromUrl = () => {
    const parsed = parseWhatsappOAuthCallbackFromSearch(window.location.search);

    if (!parsed) {
        return false;
    }

    if (parsed.kind === "error") {
        localStorage.setItem(
            WHATSAPP_OAUTH_ERROR_STORAGE_KEY,
            JSON.stringify(parsed)
        );
        return true;
    }

    localStorage.setItem(
        WHATSAPP_OAUTH_CALLBACK_STORAGE_KEY,
        JSON.stringify({
            code: parsed.code,
            state: parsed.state
        })
    );

    return true;
};

export const consumeStoredWhatsappOAuthCallback = () => {
    const stored = localStorage.getItem(WHATSAPP_OAUTH_CALLBACK_STORAGE_KEY);

    if (!stored) {
        return null;
    }

    localStorage.removeItem(WHATSAPP_OAUTH_CALLBACK_STORAGE_KEY);

    try {
        return JSON.parse(stored);
    } catch {
        return null;
    }
};

export const consumeStoredWhatsappOAuthError =
    (): WhatsappOAuthCallbackError | null => {
        const stored = localStorage.getItem(WHATSAPP_OAUTH_ERROR_STORAGE_KEY);

        if (!stored) {
            return null;
        }

        localStorage.removeItem(WHATSAPP_OAUTH_ERROR_STORAGE_KEY);

        try {
            const parsed = JSON.parse(stored);

            if (parsed?.kind === "error" && parsed?.error) {
                return parsed;
            }

            return null;
        } catch {
            return null;
        }
    };

export const getWhatsappOAuthErrorFromSearch = (search: string) => {
    const parsed = parseWhatsappOAuthCallbackFromSearch(search);

    if (!parsed || parsed.kind !== "error") {
        return null;
    }

    return parsed;
};
